import * as React from 'react';
import { Select } from 'antd';

export const AcquisitionSource = (props: { acquisition_sources: string[] }) => {
    return (
        <Select showSearch dropdownMatchSelectWidth={false} {...props}>
            {props.acquisition_sources.map((source: string, index: number) => {
                return (
                    <Select.Option key={index} value={source}>
                        {source}
                    </Select.Option>
                );
            })}
        </Select>
    );
};
